import { Input, Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import * as ProgressBar from 'progressbar.js';
import 'owl.carousel';


declare var $: any;

@Component({
  selector: 'app-stackedbar',
  templateUrl: './stackedbar.component.html',
  styleUrls: ['./stackedbar.component.scss']
})
export class StackedbarComponent implements OnInit {



  @Input() consumption: any;
  @ViewChild('container') container: ElementRef;
  total = 0
  devices = []
  ngOnInit(): void {




    $('.carousel').carousel('pause');
    $('.multi-item-carousel').on('slide.bs.carousel', function (e) {

      let $e = $(e.relatedTarget),
        itemsPerSlide = 3,
        totalItems = $('.carousel-item', this).length,
        $itemsContainer = $('.carousel-inner', this),
        it = itemsPerSlide - (totalItems - $e.index());
      console.log(totalItems);

      if (it > 0) {
        for (var i = 0; i < it; i++) {
          $('.carousel-item', this).eq(e.direction == "left" ? i : 0).
            appendTo($itemsContainer);
        }
      }
    });
  }
  ngAfterViewInit() {
    $('.carousel').carousel({
      interval: 6000
    })
  }
  renderCircle(id, percentage) {
    var bar = new ProgressBar.Circle(id, {
      strokeWidth: 8,
      easing: 'easeInOut',
      duration: 100,
      color: '#ee3253',
      trailColor: '#eee',
      trailWidth: 8,
      svgStyle: {
        "stroke-linecap": "round"
      }
    });

    bar.setText((percentage * 100).toFixed(1) + "%");
    bar.animate(percentage);
  }

  ngOnChanges() {
    this.devices = [];
    this.total = 0;
    if (this.consumption) {
      this.consumption.forEach((item, index) => {
        this.total += item.consumption
        console.log(this.total);

        this.devices.push(item)
      })

      setTimeout(() => {
        this.devices.forEach((item, index) => {
          this.renderCircle(('#container' + index), (item.consumption / this.total))
        });
      }, 1000)

    }

  }


}
